import CONSTANTS from "./constants";
import BaseHttpHandler from "./utilities/baseHttpHandler";

// Gets all agents
async function getAllAgents() {
  try {
    let instance = await BaseHttpHandler.getInstance();

    const response = await instance.get(
      CONSTANTS.API_CONSTANTS.ENDPOINTS
        .CONTACT_CENTRE_CALL_MANAGER_AGENTS_MONITOR,
      {
        cancelToken: BaseHttpHandler.getTimedCancelToken().token,
      }
    );

    return response.data;
  } catch (e) {
    // If the endpoint returns anything other a 200 response okay message we need to know about it and handle it appropriately
    console.log(e);
    throw e;
  }
}

// Sets a team's registration status
async function setTeamRegistrationStatus(id, status) {
  try {
    let instance = await BaseHttpHandler.getInstance();

    const response = await instance.post(
      CONSTANTS.API_CONSTANTS.ENDPOINTS
        .CONTACT_CENTRE_CALL_MANAGER_TEAM + id + '/Status/' + status,
      {
        cancelToken: BaseHttpHandler.getTimedCancelToken().token,
      }
    );

    return response.data;
  } catch (e) {
    // If the endpoint returns anything other a 200 response okay message we need to know about it and handle it appropriately
    console.log(e);
    throw e;
  }
}

// Sets a user's status code
async function setStatusCode(statusCode) {
  try {
    let instance = await BaseHttpHandler.getInstance();

    return await instance.put(
      CONSTANTS.API_CONSTANTS.ENDPOINTS
        .CONTACT_CENTRE_CALL_MANAGER_STATUS + statusCode,
      {
        cancelToken: BaseHttpHandler.getTimedCancelToken().token,
      }
    );
  } catch (e) {
    // If the endpoint returns anything other a 200 response okay message we need to know about it and handle it appropriately
    console.log(e);
    throw e;
  }
}

// Sets a user's reason code
async function setReasonCode(reasonCode) {
  try {
    let instance = await BaseHttpHandler.getInstance();

    return await instance.put(
      CONSTANTS.API_CONSTANTS.ENDPOINTS
        .CONTACT_CENTRE_CALL_MANAGER_REASON + reasonCode,
      {
        cancelToken: BaseHttpHandler.getTimedCancelToken().token,
      }
    );
  } catch (e) {
    // If the endpoint returns anything other a 200 response okay message we need to know about it and handle it appropriately
    console.log(e);
    throw e;
  }
}

async function requestAssistance() {
  try {
    let instance = await BaseHttpHandler.getInstance();

    const response = await instance.post(
      CONSTANTS.API_CONSTANTS.ENDPOINTS.CONTACT_CENTRE_CALL_MANAGER_REQUEST_ASSISTANCE,
      {
        cancelToken: BaseHttpHandler.getTimedCancelToken().token,
      }
    );

    return response.status;
  } catch (e) {

    console.log(e);
    throw e;
  }
}

export default {
  getAllAgents,
  setTeamRegistrationStatus,
  setStatusCode,
  setReasonCode,
  requestAssistance,
};
